import { useEffect } from 'react'
import { useRouter, Feature } from '@popety_io/popety-io-lib'

import HistoryMapClickModal from '../../../../../components/HistoryMapClickModal'

export type ListingClickModalProps = Feature & {
  setClickFeature?: (feature?: Feature) => void
}

const ListingClickModal = ({
  properties,
  setClickFeature,
}: ListingClickModalProps) => {
  const listingByLandId = {}
  const { query } = useRouter()

  const faoRange = ''

  const handleModalClose = () => {
    setClickFeature?.(undefined)
  }

  useEffect(() => {
    setClickFeature?.(undefined)
  }, [query.tab])

  return (
    <HistoryMapClickModal
      open={!!properties}
      onClose={handleModalClose}
      landId={properties?.land_id}
      dataByLandId={listingByLandId}
      value={faoRange}
    />
  )
}

export default ListingClickModal
